import React from 'react';

import Button from '../Button/Button';
import appleCalendar from '../../assets/apple-icon.svg';

import style from './AppleCalendarButton.module.scss';

const AppleCalendarButton = ({className = ''}) => {
    const handleClick = () => {
        window.open("/weddingEvent.ics", "_blank")
    }

    return (
        <Button secondary small className={`${style.button} ${className}`} onClick={handleClick}>
            <img alt="Apple Calendar Icon" src={appleCalendar} className={style.icon} /> Добави в Apple Calendar
        </Button>
    )
}

export default AppleCalendarButton;